import { Component, EventEmitter, AfterViewInit, AfterViewChecked, OnInit, Output, ViewChild, ViewContainerRef, ElementRef, HostListener, OnChanges, Input, Inject, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { CountyDropdownComponent } from 'src/app/component/common-components/county/county-dropdown/county-dropdown.component';
import { RegionDropdownComponent } from 'src/app/component/common-components/region/region-dropdown/region-dropdown.component';

// CREATE imports start here
import { UntypedFormArray, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm, ValidationErrors } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

// models
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { PARTYROLE, Region } from 'src/app/model/region.model';
import { AppState } from 'src/app/reducers';
import { PartyContactMechanisms } from '../../../party/model/party-contact-mechanisms.model';
import { MsgModel } from '../../../common-components/msg/model/msg.model';
import { PartyRoleTypes } from 'src/app/component/party/model/party-role-types.model';

// services
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DistrictEntityService } from 'src/app/component/common-components/service/district-entity.service';
import { CountyEntityService } from 'src/app/component/common-components/service/county-entity.service';
import { RegionEntityService } from 'src/app/component/common-components/service/region-entity.service';
import { PartyRolesService } from 'src/app/component/party/service/party-roles.service';
import { ApiSchoolDistrictsService } from 'src/app/service/api-school-districts.service';
import { OrganizationService } from '../../../common-components/organizations/service/organization.service';
import { Observable, Subject } from 'rxjs'; // filter, debounceTime, map, Subscription, takeUntil
import Swal from 'sweetalert2';

import { HelperService } from 'src/app/service/helper.service';
import { Store } from '@ngrx/store';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

// for Auth
import { UserProfileService } from '../../../user-profile/service/user-profile.service';
import { User } from '../../../auth/model/user.model';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
    selector: 'app-create-school-districts',
    templateUrl: './create-school-districts.component.html',
    styleUrls: ['./create-school-districts.component.scss']
})
export class CreateSchoolDistrictsComponent implements OnInit, OnChanges {
    @ViewChild(RegionDropdownComponent) child2!: RegionDropdownComponent;
    @ViewChild(CountyDropdownComponent) child3!: CountyDropdownComponent;
    @ViewChild('schoolDistrictCode') nextField2!: ElementRef;
    @Input() isCreated: boolean = false; 
    @Output() btnClick = new EventEmitter(); // to disable school code buttons when not in edit mode
    @Output() btnClick2 = new EventEmitter(); // to disable school code buttons when not in edit mode
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() createdStatusChanged = new EventEmitter<boolean>(); 
    
    // CREATE properties start here
    bShowCreateForm: boolean = false;
    bShowSearchForm: boolean = true;
    createBtnText: string = 'Create';
    bCancelCreate: boolean = false;
    bClearRegionsOnce: boolean = true;
    isInitialLoad: boolean = true;

    selected = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);
    selectedTab = new UntypedFormControl(0);
    formCtrl = new UntypedFormControl();
    myForm = new UntypedFormArray([new UntypedFormControl('', Validators.required)]);
    schoolDistrictRegionFC = new UntypedFormControl('', [Validators.required]);
    schoolDistrictCountyFC = new UntypedFormControl('', [Validators.required]);
    schoolDistrictNameFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(100)]));
    schoolDistrictCodeFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)]));
    schoolDistrictNcesFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(7)]));

    region!: Region;
    regionCap!: Region;
    district!: SchoolDistrict;

    resetField: boolean = false;
    selectedCounty: number | undefined;
    myCounty: County;
    myCounties: County[] = [];
    newNumArray: number[] = [];
    myRegions: Region;
    selectedSchoolDistrict: number = 0;
    selectedDistrict: number | undefined;
    schoolDistricts: SchoolDistrict[] = [];
    allSchoolDistricts: SchoolDistrict[] = [];
    allSchoolCounties: County[] = [];
    allSchoolRegions: Region[] = [];
    schoolRegionIds: number[] = [];
    schoolDistrictIds: number[] = [];
    selectedSchoolDistrictIds: number[] = [];
    selectedSchoolDistrictName: string | undefined;
    customRegionLabel: string = "School District's Region *";
    customCountyLabel: string = "School District's County *";

    events: string[] = []; // this is for date events
    saveButtonToShow: string = 'generalinfo'; // choices are: generalinfo, contactinfo, schoollocation
    isUneditable: boolean = false;
    schoolDistrictID: number = 0;
    selectedRegion: string = '';
    schoolDistrictNCES: string = '';
    districtNCES: string = '';
    selectedNcesCode: string = '';
    user: User = {};
    partyRoles: PARTYROLE[] = [];
    userIdChanged: boolean = false;
    partyRoleTypes: PartyRoleTypes[] = [];
    partyRoleType1: PartyRoleTypes;
    partyRoleType2: PartyRoleTypes;
    partyContactMechanisms: PartyContactMechanisms[] = [];
    isEditingPartyContactMechanisms: Event; //boolean = false;
    isLoading: boolean = false;
    loadingCounter: number = 0;
    isDone: boolean = false;
    msg: MsgModel = {};
    userIdChangedMsg: MsgModel = {};

    // nces checks
    ncesValid: boolean = true;
    ncesChecking: boolean = false;
    ncesChecked: boolean = false;

    // auth
    canEditSchoolNCES: boolean = false;
    promises: Array<any> = [];
    filteredOptions!: Observable<any>;
    private unsubUsername$: Subject<void> = new Subject<void>();
    myError: string = '';

    createSchoolDistrictForm!: UntypedFormGroup;
    organizationService!: OrganizationService;
    schoolDistrict: SchoolDistrict;
    schoolDistrictName: string = '';
    schoolDistrictCode: number;
    resetSchoolDistrictCode: number;
    organizationId!: number;
    loadedDistricts$: Observable<boolean>;
    loadedCounties$: Observable<boolean>;
    type: string = 'Organization';

    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }

    selectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);
    nativeSelectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);
    matcher = this;

    // dialog to parent components
    isOverflowEnabled: boolean;
    
    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<CreateSchoolDistrictsComponent>,
     	@Inject(MAT_DIALOG_DATA) public editData: any,
        // CREATE injects start here
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private schoolDistrictsAPIService: ApiSchoolDistrictsService,
        private _organizationService: OrganizationService,
        private schoolDistrictService: DistrictEntityService,
        private schoolCountyService: CountyEntityService,
        private schoolRegionService: RegionEntityService,
        private store: Store<AppState>,
        private helperService: HelperService,
        private partyRolesService: PartyRolesService,
        private utilityService: UtilityService,
        private cdr: ChangeDetectorRef
    ) {
        this.organizationService = _organizationService;

        this.customInit();
        this.loadingCounter = this.loadingCounter + 1;
        this.loadedDistricts$ = schoolDistrictService.loaded$;
        this.loadedCounties$ = schoolCountyService.loaded$;

        this.subscribers();
        this.isOverflowEnabled = this.editData?.isOverflowEnabled ?? false;
    }
 
 	ngOnChanges(changes: SimpleChanges)
    {
       if (changes['isCreated'])
        {
            console.log("toggling recognize ngOnChanges for isCreated")
            this.toggleOverflow();
        } 
    }

    ngAfterViewChecked(): void
    {
        this.cdr.detectChanges();  // Manually trigger change detection
        if (this.editData.isOverflowEnabled) {
            console.log("toggling recognize ngAfterViewChecked")
          this.toggleOverflow();  // Trigger the toggle when the div is shown
        }
        
         if (this.bClearRegionsOnce && this.child2.selectedRegionIds.length > 0) {
            this.child2.selectedRegionIds = [];
            this.child2.deSelectAll();
            this.bClearRegionsOnce = false;
        }
    }

    
    toggleOverflow()
    {
        if (this.editData.toggleOverflow)
        {
            console.log("toggling overflow in createschool");
            this.editData.toggleOverflow();
        }
    }
    
    customInit(): void {
        this.createSchoolDistrictForm = this.fb.group({
            schoolDistrictNameFC: new UntypedFormControl({}, Validators.compose([Validators.required, Validators.maxLength(100)])),
            schoolDistrictCodeFC: new UntypedFormControl({}, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])),
            schoolDistrictNcesFC: new UntypedFormControl({}, Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(5)])),
            schoolDistrictRegionFC: new UntypedFormControl({}, Validators.required),
            schoolDistrictCountyFC: new UntypedFormControl({}, Validators.required)
        });
   		if (!this.isCreated)
        {  
            this.editData.isCreated = this.isCreated;       
        }
        else
        {
             this.editData.isCreated = this.isCreated;  
        }
        this.resetField = false;
        this.isInitialLoad = true;
        this.schoolDistrictID = 12;
        this.createdStatusChanged.emit(this.isCreated);
    }

    ngOnInit(): void {
        this.getPartyRoleTypes();
        console.log('calling ngOnInit');
    }

    ngAfterViewInit(): void {}



    disableTabButton(tab: number) {
        if (tab == 1) {
            let inRegions: string = this.child2?.selectedRegionIds.toString();
            let inCounties: string = this.child3?.selectedCountyIds.toString();
            let inSchoolDistrictName: string = this.schoolDistrictName;
            let inSchoolDistrictNCES: string = this.schoolDistrictNcesFC?.value;
            let inSchoolDistrictCode: string = this.schoolDistrictCodeFC?.value;

            if (
                inRegions?.length > 0 &&
                inCounties?.length > 0 &&
                inSchoolDistrictName?.length > 0 &&
                inSchoolDistrictNCES?.length > 0 &&
                inSchoolDistrictCode?.length > 0
            ) {
                return false;
            }
        }
        return true;
    }

    checkDistrictRegionValid() {
        if (this.child2?.selectedRegionIds) {
            if (this.child2?.selectedRegionIds?.length > 0) {
                return true;
            }
        }
        //console.log("calling checkDistrictRegionValid returning false")
        return false;
    }

    checkDistrictCountyValid() {
        if (this.child3?.selectedCountyIds) {
            if (this.child3?.selectedCountyIds?.length > 0) {
                return true;
            }
        }
        //console.log("checkDistrictCountyValid returning false")
        return false;
    }

    checkDistrictNameValid() {
        if (this.schoolDistrictName.length > 0 && this.schoolDistrictName.length <= 100) {
            return true;
        }
        //console.log("checkDistrictNameValid returning false2")
        return false;
    }

    checkDistrictCodeValid() {
        let dcLen = this.schoolDistrictCode?.toString().length;
        if (dcLen > 0 && dcLen <= 5) {
            console.log('returning true');
            if (dcLen < 5) {
                this.myError = 'School District Code is 5 characters long.';
                return false;
            } else {
                return true;
            }
        }
        console.log('checkdistrctcodevalid returning false');
        return false;
    }

    checkDistrictNCESValid() {
        console.log('checkDistrictNCESValid');
        console.log(this.schoolDistrictNCES);
        let ncesLen = this.schoolDistrictNCES?.toString().length;

        if (ncesLen > 0) {
            if (ncesLen > 7) {
                this.myError = 'School District NCES is 7 characters long.';
                return false;
            } else {
                return true;
            }
        } else {
            console.log('checkdistrictncesvalid returning false');
        }
        return false;
    }

    checkValid() {
        let retVal: boolean = true;
        let districtRegionCheck: boolean = true;
        let districtCountyCheck: boolean = true;
        let districtNameCheck: boolean = true;
        let districtCodeCheck: boolean = true;
        let districtNcesCheck: boolean = true;
        let errorStr: string = '';

        districtRegionCheck = this.checkDistrictRegionValid();
        districtCountyCheck = this.checkDistrictCountyValid();
        districtNameCheck = this.checkDistrictNameValid();
        districtCodeCheck = this.checkDistrictCodeValid();
        districtNcesCheck = this.checkDistrictNCESValid();
        retVal = districtRegionCheck && districtCountyCheck && districtNameCheck && districtCodeCheck && districtNcesCheck;
        console.log('checkValid returning:');
        console.log(retVal);
        if (!retVal) {
            errorStr = 'There are errors, please check your input(s): ';

            if (!districtRegionCheck) errorStr = errorStr + ' Invalid District Region. ';
            if (!districtCountyCheck) errorStr = errorStr + ' Invalid District County. ';
            if (!districtNameCheck) errorStr = errorStr + ' Invalid District Name. ';
            if (!districtCodeCheck) errorStr = errorStr + ' Invalid District Code. ';
            if (!districtNcesCheck) errorStr = errorStr + ' Invalid District NCES. ';

            this.myError = errorStr;
        } else {
            this.myError = '';
        }
        return retVal;
    }

    getFormValidationErrors(form: UntypedFormGroup) {
        if (form) {
            type newObj = { [key: string]: any };

            let res: newObj = {};

            Object.keys(form.controls).forEach((key: string) => {
                if (key.trim() != 'txtErrorMsg') {
                    let controlErrors: ValidationErrors = <UntypedFormControl>form.get(key)!.errors;
                    if (controlErrors != null) {
                        console.log('control errors');
                        console.log(controlErrors);
                        Object.keys(controlErrors).forEach((keyError) => {
                            if (keyError == 'pattern') {
                                console.log('no error');
                            } else {
                                res[key] = keyError;
                                console.log('found errors');
                                console.log('for control');
                                console.log(key);
                                console.log(keyError);
                            }
                        });
                    }
                }
            });
            console.log('getFormValidation errors returning');
            console.log(Object.keys(res).length);
            console.log(res);
            return Object.keys(res).length === 0 ? null : res;
        } else {
            console.log('getFormValidation errors returning null');
            return null;
        }
    }

    @HostListener('window:keyup', ['$event'])
    onKeyDown(e: any) {
        const pattern = /[0-9\+\-\ ]/;
        //console.log(e.srcElement.id);
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed');
                e.preventDefault();
            } else {
                if (e.srcElement.id == 'schoolDistrictNCES') {
                    this.fnCheckNCESDistrictCode(e);
                }
            }
        }
    }

    onKeyUp(e: any) {
        if (e.srcElement.value.length >= e.srcElement.maxLength) {
            e.preventDefault();
        }
    }

    regionEventEmitter(lstRegion: Region[]) {
        this.loadingCounter = this.loadingCounter + 1;
        if (this.loadingCounter > 3) {
            this.fnDeactivateInitialLoad();
            if (this.child2?.selectedRegionIds == undefined) {
                this.isInitialLoad = false;
                this.selectedSchoolDistrict = 0;
            }
        }
        this.schoolDistrictNCES = '';
        this.selectedNcesCode = '';
    }

    getPartyRoleTypes() {
        this.partyRolesService.indexPartyRoleTypesByCategory(this.type).subscribe((res) => {
            const type = this.type;
            //console.log("here are all the party role types")
            // console.log(res.partyRoleTypes)

            this.partyRoleType1 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === type;
            });

            this.partyRoleType2 = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === 'School District';
            });

            this.partyRoleTypes.push(this.partyRoleType1);
            this.partyRoleTypes.push(this.partyRoleType2);
        });
    }

    fnDeactivateInitialLoad() {
        this.isInitialLoad = false;
        this.loadingCounter = 4;
    }

    fnCreateAnother() {
        this.myError = '';
        this.isInitialLoad = true;
        this.loadingCounter = 0;
        this.isUneditable = !this.isUneditable;
        if (!this.isUneditable) {
            this.createBtnText = 'Creating...';
            this.bCancelCreate = true;

            this.customInit();
            this.fnReset2();
            setTimeout(() => {
                this.isCreated = false;
            }, 500);
        } else {
            this.bCancelCreate = false;
            this.createBtnText = 'Create';
        }
    }

    fnSaveCreate() {
        console.log('saving create');
        this.myError = '';
        if (this.checkValid()) {
            // this needs to be cleared each time prior to a new save
            let inOrgId: number = this.organizationId;
            let inSchoolDistrictName: string = this.schoolDistrictName;
            let inSchoolDistrictNCES: string = this.schoolDistrictNcesFC?.value;
            let inSchoolDistrictCode: string = this.schoolDistrictCodeFC?.value;

            let createSchoolDistrict: SchoolDistrict = new SchoolDistrict();
            if (inOrgId != null) {
                createSchoolDistrict.ORGANIZATIONS_ID = inOrgId;
            }
            if (inSchoolDistrictName != null) {
                createSchoolDistrict.DISTRICTS = inSchoolDistrictName;
            }
            if (inSchoolDistrictCode != null) {
                createSchoolDistrict.CODE = inSchoolDistrictCode;
            }
            if (inSchoolDistrictNCES != null) {
                createSchoolDistrict.NCESDist = inSchoolDistrictNCES;
            }

            let inCounties: string = this.child3?.selectedCountyIds.toString();
            let inCountyName: string = this.child3?.selectedCountyName || '';
            let inRegions: string = this.child2?.selectedRegionIds.toString();
            let inRegionName: string = this.child2?.selectedRegionName || '';

            var editRegion: any;
            editRegion = this.getSpecificRegion(parseInt(inRegions));
            var editCounty: any;
            editCounty = this.getSpecificCounty(parseInt(inCounties));
            createSchoolDistrict.REGIONS = editRegion;
            createSchoolDistrict.COUNTy = editCounty;

            console.log('passing to API');
            console.log(createSchoolDistrict);

            Swal.fire({
                title: 'Are you sure you want to save?',
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                denyButtonText: ``
            }).then((result) => {
                if (result.isConfirmed && this.myError == '') {
                    let params: any;
                    params = {
                        schoolDistrict: createSchoolDistrict,
                        partyRoleTypes: this.partyRoleTypes
                    };
                    this.schoolDistrictsAPIService.Create(params).subscribe({
                        next: (res: any) => {
                            if (res.msg.MSG.length > 5 && res.msg.MSG != 'Successfully created new school district.') {
                                console.log('Error saving create: ' + res.msg.MSG);
                                this.myError = 'Error saving: ' + res.msg.MSG;
                            } else {
                                this.isUneditable = true;
                                this.bCancelCreate = false;
                                this.createBtnText = 'Create';
                                this.isCreated = true;
                                this.bShowCreateForm = false;
                            }
                        },
                        error: (err: any) => {
                            console.log('error while creating school district: ' + Object.entries(err));
                        }
                    });
                } else {
                    console.log('errored out so we are not saving');
                }
            });
        } else {
            console.log('save create was not valid');
            this.fnDeactivateInitialLoad();
        }
    }

    getSpecificDistrict(id: number): SchoolDistrict | null {
        for (var i = 0; i < this.allSchoolDistricts.length; i++) {
            if (this.allSchoolDistricts[i].ID == id) {
                return this.allSchoolDistricts[i];
            }
        }
        return null;
    }

    getSpecificRegion(id: number): Region | null {
        console.log('calling getSpecificRegion');
        console.log(this.allSchoolRegions?.length);
        for (var i = 0; i < this.allSchoolRegions?.length; i++) {
            if (this.allSchoolRegions[i]?.ID) {
                if (this.allSchoolRegions[i]?.ID == id) {
                    console.log('found region');
                    console.log(this.allSchoolRegions[i]);
                    return this.allSchoolRegions[i];
                }
            }
        }
        console.log('returning null');
        return null;
    }

    getSpecificCounty(id: number): County | null {
        for (var i = 0; i < this.allSchoolCounties.length; i++) {
            if (this.allSchoolCounties[i].ID == id) {
                return this.allSchoolCounties[i];
            }
        }
        return null;
    }

    fnCheckNCESDistrictCode(evt?: Event) {
        this.myError = '';
        this.ncesValid = false;
        this.ncesChecking = true;
        if (!this.schoolDistrictNCES) {
            // console.log('nces code had blank inputs');
            // if user did not enter anything, this is not an error
            // this.myError = 'Error checking NCES District Code:  ncesCode was blank for this school.';
            // this.ncesValid = false;
        } else {
            this.schoolDistrictsAPIService.checkDistrictNCES(parseInt(this.schoolDistrictNCES), this.schoolDistrictID).subscribe({
                next: (res: any) => {
                    console.log('ncesCodeCheck returned: ');
                    console.log(Object.entries(res.msg));
                    setTimeout(() => {
                        if (res.msg['SUCCESS'] == false) {
                            this.myError = 'Error checking nces district Code:' + res.msg['MSG'];
                            this.ncesValid = false;
                            this.ncesChecking = false;
                        } else {
                            this.ncesValid = true;
                            this.ncesChecking = false;
                            this.ncesChecked = true;
                            this.myError = '';
                        }
                    }, 2000);
                },
                error: (err: any) => {
                    setTimeout(() => {
                        this.myError = 'Error checking NCES District Code, please try again:' + err.toString();
                        console.log('nces check returned error:');
                        console.log(err.toString());
                        this.ncesValid = false;
                        this.ncesChecking = false;
                    }, 2000);
                }
            });
        }
    }

    pad(num: number) {
        return ('00' + num).slice(-2);
    }

    ngOnDestroy(): void {
        this.unsubUsername$.next();
        this.unsubUsername$.complete();
    }

    // for Auth
    fnCheckCanEditSchoolNCES() {
        // until sec roles have been implemented, we will set this as true
        this.canEditSchoolNCES = true;
    }

    catchSubmitError(err: any) {
        console.log('submit edits caught error:' + err);
        this.myError = 'Error during submit:' + err;
    }

    /*getUserProfile() {
    let deferred = new Promise((resolve, reject) => {
      this.userProfileService.getMyProfile().subscribe((res) => {
        if (res?.user) {
          this.user = res.user;

          resolve(res);
        } else if (res?.msg) {
          reject(res);
        } else {
          reject('err');
        }
      });
    });
    this.promises.push(deferred);
  }*/

    fnReset() {
        setTimeout(() => {
            ///this.fnSetInitialData();
            this.createSchoolDistrictForm.reset();
            this.child2.deSelectAll();
            this.schoolDistrictName = '';
            this.schoolDistrictCode = this.resetSchoolDistrictCode;
            this.child3.deSelectAll();
        }, 1000);
    }

    fnReset2() {
        setTimeout(() => {
            this.createSchoolDistrictForm.reset();
            this.child2.deSelectAll();
            this.schoolDistrictName = '';
            this.schoolDistrictCode = this.resetSchoolDistrictCode;
            this.child3.deSelectAll();
        }, 2000);
    }

    closeRecord() {
        if (this.isUneditable) {
            this.dialogRef.close();
        } else {
            Swal.fire({
                title: 'Are you sure you want to stop editing and discard all changes made?',
                showDenyButton: true,
                showConfirmButton: false,
                showCancelButton: true,
                denyButtonText: `Confirm`
            }).then((result) => {
                console.log('now closing way');
                if (result.isDenied) {
                    Swal.fire('Changes are not saved', '', 'info');
                    this.fnReset();
                    this.dialogRef.close();
                }
                if (result.isConfirmed) {
                    this.dialogRef.close();
                } else {
                    // do nothing except close popup swal confirmation
                }
            });
        }
    }

    onCreateEvent(inCreateParm: any) {
        this.bShowCreateForm = true;
        this.bCancelCreate = true;
        this.createBtnText = 'Creating...';
        this.isUneditable = !this.isUneditable;
    }

    countiesSelected(counties: County[]) {
        this.eventEmitterCountycode.emit(counties);
        this.schoolDistrictNCES = '';
        this.selectedNcesCode = '';
    }

    subscribers() {
        let schoolRegionsEntitiesSub = this.schoolRegionService.entities$.subscribe((schoolRegions: Region[]) => {
            this.allSchoolRegions = schoolRegions;
            this.schoolRegionIds = this.allSchoolRegions.length > 0 ? this.allSchoolRegions.map((schoolRegion) => schoolRegion.ID!) : [];
        });

        let schoolDistrictEntitiesSub = this.schoolDistrictService.entities$.subscribe((schoolDistricts: SchoolDistrict[]) => {
            this.allSchoolDistricts = schoolDistricts;
            this.schoolDistrictIds = this.allSchoolDistricts.length > 0 ? this.allSchoolDistricts.map((schoolDistrict) => schoolDistrict.ID!) : [];
        });

        let schoolCountyEntitiesSub = this.schoolCountyService.entities$.subscribe((schoolCounties: County[]) => {
            this.allSchoolCounties = schoolCounties;
        });
    }
}
